import { createAction } from '@reduxjs/toolkit';

export const schedulerGetDraftRequest = createAction('scheduler/getDraftRequest');
export const schedulerGetDraftError = createAction('scheduler/getDraftError');
export const schedulerGetDraftStore = createAction('scheduler/getDraftStore');

export const schedulerUpdateIsDraft = createAction('scheduler/updateIsDraft');

export const schedulerUpdatePostStore = createAction('scheduler/updatePostStore');

export const schedulerUpdateRequest = createAction('scheduler/updateRequest');
export const schedulerUpdateError = createAction('scheduler/updateError');
export const schedulerUpdateStore = createAction('scheduler/updateStore');

export const schedulerUpdateId = createAction('scheduler/updateId');
export const schedulerUpdateTitle = createAction('scheduler/updateTitle');
export const schedulerUpdateContent = createAction('scheduler/updateContent');
export const schedulerUpdateImages = createAction('scheduler/updateImages');

export const schedulerUpdateFB = createAction('scheduler/updateFB');
export const schedulerUpdateTW = createAction('scheduler/updateTW');
export const schedulerUpdateIG = createAction('scheduler/updateIG');
export const schedulerUpdateLI = createAction('scheduler/updateLI');
export const schedulerUpdateTG = createAction('scheduler/updateTG');
export const schedulerUpdatePI = createAction('scheduler/updatePI');
export const schedulerUpdateTR = createAction('scheduler/updateTR');
export const schedulerUpdateDI = createAction('scheduler/updateDI');

export const schedulerUpdatePublishResult = createAction('scheduler/updatePublishResult');

// Multi-account actions — each platform may have N selected accounts,
// and each (platform × account) pair may have its own text/files override.
export const schedulerToggleAccount = createAction('scheduler/toggleAccount'); // { platformId, accountId }
export const schedulerSetSelectedAccounts = createAction('scheduler/setSelectedAccounts'); // { platformId, accountIds: number[] }
export const schedulerSetAccountContent = createAction('scheduler/setAccountContent'); // { platformId, accountId, textBody, files }
export const schedulerInitAccountCustoms = createAction('scheduler/initAccountCustoms'); // { platformId, accountId, baseTextBody, baseFiles }
export const schedulerClearAllAccounts = createAction('scheduler/clearAllAccounts');
